import React, {SVGProps} from "react";

export const IconClose = (props: SVGProps<SVGSVGElement>) => {
    const {color = "currentColor", width = "24", height = "24", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            {...rest}
        >
            <path d="M5 5.25L19 19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M19 5.25L5 19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
